import { Component, OnInit } from "@angular/core";
import { QueryModel } from "app/models/queryModel";
import { UserService } from "app/services/user.service";
import { SessionService } from "app/services/session.service";
import { AuthTokenService } from "app/services/auth-token.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmPasswordValidator } from "./confirm-password.validator";
import Swal from "sweetalert2/dist/sweetalert2.js";

@Component({
  selector: "app-users-list",
  templateUrl: "./users-list.component.html",
  styleUrls: ["./users-list.component.css"],
})
export class UsersListComponent implements OnInit {
  constructor(
    private userService: UserService,
    private sessionService: SessionService,
    private AuthTokenService: AuthTokenService,
    private fb: FormBuilder
  ) { }
  date: Date = new Date();
  registerForm: FormGroup;
  submitted: boolean = false;
  users: any[];
  passwordCapture: any;
  editable: Boolean = false;
  queryModelSetScope: QueryModel = new QueryModel();
  customerInfo: any;
  password: any = "";
  confirmPassword: any = "";
  user: any;
  openModal() {
    var modal = document.getElementById("myModal");
    modal.style.display = "block";
  }
  closeModal() {
    var modal = document.getElementById("myModal");
    this.registerForm.reset();
    this.registerForm.markAsPristine();
    this.registerForm.markAsUntouched();
    this.registerForm.clearAsyncValidators();
    modal.style.display = "none";
  }

  editUser(index) {
    this.user = this.users[index];

    var modal = document.getElementById("myModal");
    modal.style.display = "block";
  }

  ngOnInit() {
    let depots = this.sessionService.getSites();
    let selectedCode;
    const selectedDepo = this.sessionService.getSiteId();
    if (selectedDepo == null || selectedDepo == 0) {
      selectedCode = null;
    } else {
      let selectedOne = depots.find((obj) => obj.id == selectedDepo);
      selectedCode = selectedOne.description.substring(0, 4);
    }
    var UserName = this.sessionService.getUserName();
    this.customerInfo = this.AuthTokenService.getToken();
    this.queryModelSetScope.request.query = "proc_admin_view_users";
    this.queryModelSetScope.request.parameters.push(
      this.customerInfo.token_link
    );
    this.queryModelSetScope.request.parameters.push(selectedCode);
    this.queryModelSetScope.request.skip = true;
    this.queryModelSetScope.authorise_token = this.customerInfo.token;
    this.queryModelSetScope.authorise_link = this.customerInfo.token_link;
    this.userService.GetMethod(this.queryModelSetScope).subscribe((res) => {
      this.users = res.body.data;
    });

    this.registerForm = this.fb.group(
      {
        password: ["", Validators.required],
        confirmPassword: ["", Validators.required],
      },
      {
        validator: ConfirmPasswordValidator("password", "confirmPassword"),
      }
    );
  }

  captureValue(value, i) {
    this.passwordCapture = value;
  }
  onSubmit() {
    this.submitted = true;
  }
  updatePasswordForm() {
    this.customerInfo = this.AuthTokenService.getToken();
    var userName = this.sessionService.getUserName();
    this.queryModelSetScope.request.query = "proc_admin_update_user";
    this.queryModelSetScope.request.parameters = [];
    this.queryModelSetScope.request.parameters.push(
      this.customerInfo.token_link
    );
    this.queryModelSetScope.request.parameters.push(this.user.user_link);
    this.queryModelSetScope.request.parameters.push(
      this.registerForm.value.confirmPassword
    );
    this.queryModelSetScope.request.skip = true;
    this.queryModelSetScope.authorise_token = this.customerInfo.token;
    this.queryModelSetScope.authorise_link = this.customerInfo.token_link;
    this.userService.GetMethod(this.queryModelSetScope).subscribe((res) => {
      if (res.body.message) {
        let template = `
        <div style='text-align:center'>
        <div style='margin-bottom: 10px; margin-top: 5px'>
            <b>${res.body.message}</b>
        </div>
        <div style="text-align:left; margin-left: 30px">
        `;
        var base64regex =
          /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
        for (let i = 0; i < res.body.criteria.length; i++) {
          if (base64regex.test(res.body.criteria[i]) == true) {
            console.log("Yes it is base64");
            template =
              template + `<b>${i + 1}. </b>${atob(res.body.criteria[i])} <br>`;
            i = i + 1;
          }
          template =
            template + `<b>${i + 1}. </b> ${res.body.criteria[i]} <br>`;
        }
        template = template + `</div></div>`;

        console.log("Template after completion:", template);

        Swal.fire({
          html: `${template}`,
        });
      } else if (res.body.data[0].message) {
        Swal.fire({
          icon: "success",
          title: "Password has been updated",
        });
      }
    });

    var modal = document.getElementById("myModal");
    this.registerForm.reset();
    modal.style.display = "none";
  }
}
